import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { FormParams } from '../../../interfaces/form-params';

@Component({
  selector: 'bm-time-form',
  templateUrl: './time-form.component.html',
  styleUrls: ['./time-form.component.scss']
})
export class TimeFormComponent implements OnInit {

  @HostBinding('class')
  @Input() className = '';

  @Input() params: FormParams;

  constructor() {}

  ngOnInit() {}

}
